var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"message-item f-clearfix",style:({
'margin-bottom': _vm.setMarginBottom,
'line-height': _vm.setLineHeight
})},[_c('div',{staticClass:"message-l f-left",style:({
		"width":_vm.setSize + "em",
		"color": _vm.setColor
	})},[_vm._v("\n\t\t"+_vm._s(_vm.title)+"\n\t")]),_vm._v(" "),_c('div',{staticClass:"message-r f-block",style:({"color": _vm.setColor})},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14705992","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/message-item.vue
// module id = null
// module chunks = 